import React, { useState } from 'react';
import { Search, Plus, X, Dumbbell, Activity } from 'lucide-react';

const QUICK_CARDIO_ITEMS = [
    'Hardlopen',
    'Roeien (Concept2)',
    'Assault AirBike',
    'SkiErg',
    'Loopband (Incline)',
    'Stationaire Fiets',
    'Crosstrainer',
    'Double Unders',
    'Single Unders',
    'Burpees',
    'Box Jumps'
];

export default function ExercisePicker({ searchQ, setSearchQ, setShowPicker, filteredDict, addExercise }) {
    const [tab, setTab] = useState('all'); // 'all' | 'cardio'

    const getExName = (item) => {
        if (!item) return '';
        if (typeof item === 'string') return item;
        return item.name || item.exercise_name || item.title || '';
    };

    const baseList = tab === 'cardio'
        ? QUICK_CARDIO_ITEMS.filter(c => c.toLowerCase().includes(searchQ.toLowerCase())).map(name => ({ name, isCardioPreset: true }))
        : filteredDict;

    const exactMatchExists = baseList.some(e => getExName(e).toLowerCase() === searchQ.trim().toLowerCase());

    return (
        <div className="fixed inset-0 z-[99999] bg-black/80 backdrop-blur-md flex justify-center items-start pt-12 sm:pt-20 p-4 animate-fade-in">
            <div className="bg-zinc-900 rounded-2xl w-full max-w-lg border border-zinc-700 shadow-2xl overflow-hidden flex flex-col max-h-[82vh]">
                <div className="p-4 border-b border-zinc-700 flex items-center gap-3 bg-zinc-800/50">
                    <Search size={20} className="text-orange-500 shrink-0"/>
                    <input
                        autoFocus
                        type="search"
                        value={searchQ}
                        onChange={(e) => setSearchQ(e.target.value)}
                        placeholder="Zoek oefening of cardio (bijv. Squat, Roeien)..."
                        className="w-full bg-transparent text-white outline-none font-bold text-sm sm:text-base border-none"
                        autoComplete="off"
                    />
                    <button
                        type="button"
                        onClick={() => setShowPicker(false)}
                        className="text-gray-400 hover:text-white p-1.5 bg-zinc-800 rounded-full border border-zinc-700"
                    >
                        <X size={18}/>
                    </button>
                </div>

                <div className="px-4 py-2.5 border-b border-zinc-800 flex gap-2 bg-zinc-900">
                    <button
                        type="button"
                        onClick={() => setTab('all')}
                        className={`px-3 py-1.5 rounded-lg text-xs font-black uppercase tracking-wider flex items-center gap-1.5 border transition-all ${
                            tab === 'all'
                                ? 'bg-orange-600 text-white border-orange-500'
                                : 'bg-zinc-800 text-gray-400 border-zinc-700 hover:text-white'
                        }`}
                    >
                        <Dumbbell size={14}/> Alle Oefeningen
                    </button>
                    <button
                        type="button"
                        onClick={() => setTab('cardio')}
                        className={`px-3 py-1.5 rounded-lg text-xs font-black uppercase tracking-wider flex items-center gap-1.5 border transition-all ${
                            tab === 'cardio'
                                ? 'bg-cyan-600 text-white border-cyan-500'
                                : 'bg-zinc-800 text-gray-400 border-zinc-700 hover:text-white'
                        }`}
                    >
                        <Activity size={14}/> Cardio & Ergs
                    </button>
                </div>

                <div className="overflow-y-auto custom-scrollbar p-2 flex-1 space-y-1">
                    {searchQ.trim().length > 0 && !exactMatchExists && (
                        <button
                            type="button"
                            onClick={() => addExercise(searchQ.trim())}
                            className="w-full text-left p-3.5 rounded-xl bg-orange-500/10 hover:bg-orange-500/20 text-orange-500 font-black border border-orange-500/30 transition-colors flex items-center gap-2 text-sm"
                        >
                            <Plus size={18}/> Voeg "{searchQ.trim()}" toe als eigen oefening
                        </button>
                    )}

                    {baseList.map((ex, idx) => {
                        const exName = getExName(ex);
                        if (!exName) return null;
                        const muscleTag = ex.muscleGroup || ex.muscle_group || (ex.isCardioPreset ? 'Cardio' : '');
                        return (
                            <button
                                key={`${exName}-${idx}`}
                                type="button"
                                onClick={() => addExercise(exName, !!ex.isCardioPreset)}
                                className="w-full text-left px-4 py-3 rounded-xl bg-zinc-800/40 hover:bg-orange-500/10 text-white font-bold border border-zinc-800 hover:border-orange-500/40 transition-all flex items-center justify-between gap-2"
                            >
                                <span className="text-sm sm:text-base truncate">{exName}</span>
                                {muscleTag && (
                                    <span className="text-[10px] font-black uppercase tracking-wider px-2 py-0.5 rounded bg-zinc-800 text-gray-400 border border-zinc-700 shrink-0">
                                        {muscleTag}
                                    </span>
                                )}
                            </button>
                        );
                    })}

                    {baseList.length === 0 && (
                        <div className="p-8 text-center text-gray-500 text-sm">
                            Geen oefeningen gevonden. Typ een naam hierboven om hem direct aan te maken!
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
